export default __webpack_public_path__ + "static/media/cc_1.e9db5347.mp3";